import { connect } from 'react-redux';

import { currentRequestTemplate } from 'app/developer-v3/selectors';

import RequestFields from './RequestFields';

const mapStateToProps = state => {
  return {
    requestTemplate: currentRequestTemplate(state),
  };
};

export default connect(mapStateToProps)(RequestFields);
